import React, { useState, useRef, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";


export interface Option<T> {
  label: string;
  onClick?: (item: Option<T>, context: T, index: number) => void;
};

export interface Props<T> {
  name: string;
  context: T;
  options: Option<T>[];
};


export const ContextMenuDropdown = <T extends unknown>({
                                                         name,
                                                         context,
                                                         options = [],
                                                       }: Props<T>) => {

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggle = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleItemClick = (item: Option<T>, index: number) => {
    item.onClick?.(item, context, index);
    setIsOpen(false);
  };


  return (
    <div ref={dropdownRef} style={{ position: "relative" }}>
      <Dropdown isOpen={isOpen} toggle={toggle}>
        <DropdownToggle className="p-0 m-0">
          <button className="btn bg-danger text-white font-size-12">
            {name}
          </button>
        </DropdownToggle>

        <DropdownMenu end>
          {options.map((item, index) => (
            <DropdownItem
              key={index}
              onClick={() => handleItemClick(item, index)}
            >
              {item.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};